var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1981_4647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 7.61122 26.3888 0 17 0C7.61122 0 0 7.61122 0 17C0 25.4851 6.21669 32.5182 14.3438 33.7935V21.9141H10.0273V17H14.3438V13.2547C14.3438 8.99406 16.8818 6.64063 20.765 6.64063C22.6249 6.64063 24.5703 6.97266 24.5703 6.97266V11.1563H22.4267C20.3149 11.1563 19.6562 12.4667 19.6562 13.8112V17H24.3711L23.6174 21.9141H19.6562V33.7935C27.7833 32.5182 34 25.4853 34 17Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6174 21.9141L24.3711 17H19.6562V13.8112C19.6562 12.4666 20.3149 11.1562 22.4267 11.1562H24.5703V6.97266C24.5703 6.97266 22.6249 6.64062 20.7648 6.64062C16.8818 6.64062 14.3438 8.99406 14.3438 13.2547V17H10.0273V21.9141H14.3438V33.7935C15.2225 33.9312 16.1106 34.0002 17 34C17.8894 34.0002 18.7775 33.9312 19.6562 33.7935V21.9141H23.6174Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1981_4647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f971140b09a9242fe91c33f8e5c9eed7.svg";
export { ForwardRef as ReactComponent };